module.exports = __webpack_public_path__ + "img/744.dfd5e817.jpg";